import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CiselnikyDto } from '../dto/CiselnikyDto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CiselnikyService {

  constructor(
    private http: HttpClient,
  ) { }

  private apiGetCiselniky: string = "api/Ciselnik/GetAll";

  public getAll(): Observable<CiselnikyDto> {
    return this.http.get<CiselnikyDto>(this.apiGetCiselniky);
  }
}
